import React, { } from "react";
import {
    Button,
    Radio,
    Tooltip
} from "antd";
import Container from "../../../General/Container/Container"
import { BiGrid, BiMenu } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setDisplayMode } from "../../../../store/components/TreeMapReport.slice";

function CategoryDeepDiveSwitchDisplay() {
    const dispatch = useDispatch();

    const { displayMode } = useSelector((state) => state.treemapreports)

    return (<Container className="report--displayoption drow">
        <Radio.Group value={displayMode}
        //  onChange={(e) => {
        //     dispatch(setDisplayMode(e.target.value))
        // }}
        >
            <Tooltip placement="top" title="Grid" arrow={false}><Radio value="treemap"><Button icon={<BiGrid style={{ fontSize: 19 }} />} type="icon" onClick={() => {
                dispatch(setDisplayMode("treemap"))
            }} /></Radio></Tooltip>
            <Tooltip placement="top" title="List" arrow={false}><Radio value="cards" ><Button icon={<BiMenu style={{ fontSize: 20 }} />} type="icon" onClick={() => {
                dispatch(setDisplayMode("cards"))
            }} /></Radio></Tooltip>
        </Radio.Group>
    </Container>
    );
}

export default CategoryDeepDiveSwitchDisplay;
